export default "__VITE_ASSET__BObC0Jcf__"